// +----------------------------------------------------------------------
// | Desc: 全局图标((阿里图标)选择器配置库
// +----------------------------------------------------------------------
export default {
    icon: [
        "iconfont icon-xiugai",
        "iconfont icon-shanchu",
        "iconfont icon-shenhe",
        "iconfont icon-xinzeng",
        "iconfont icon-chaxun",
        "iconfont icon-a-huaban1fuben46",
        "iconfont icon-xiangqing",
        "iconfont icon-liebiao",
        "iconfont icon-anlihuicui",
        "iconfont icon-quanxian",
        "iconfont icon-zhanghaoguanli",
        "iconfont icon-paibanoff",
        "iconfont icon-xiazai",
        "iconfont icon-chengshi-copy"
    ],
}